import { UpgradePlanModalCompassContent } from "./UpgradePlanModalCompassContent";
import type { UpgradePlanModalComponentProps } from "./UpgradePlanModalWrapper";
import { UpgradePlanModalWrapper } from "./UpgradePlanModalWrapper";
import type { UpgradePlanModalWrapperProps } from "./UpgradePlanModalWrapper";

export interface UpgradePlanModalComponentExternalProps extends Omit<
  UpgradePlanModalWrapperProps,
  "children"
> {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const UpgradePlanModalComponent = ({
  open,
  onOpenChange,
  ...wrapperProps
}: UpgradePlanModalComponentExternalProps) => (
  <UpgradePlanModalWrapper {...wrapperProps}>
    {(modalProps: UpgradePlanModalComponentProps) => (
      <UpgradePlanModalCompassContent
        open={open}
        onOpenChange={onOpenChange}
        {...modalProps}
      />
    )}
  </UpgradePlanModalWrapper>
);
